export default __webpack_public_path__ + "static/romance-scam-0e7135033b42c366d6c020b85425be19.webp";